export const formatLastPeriodValueOneDecimal = (
  value: number | string | undefined,
): string => {
  let numericValue: number | undefined;
  if (typeof value === "number") {
    numericValue = value;
  } else if (value != null) {
    const coerced = Number(value);
    numericValue = Number.isFinite(coerced) ? coerced : undefined;
  }
  if (numericValue === undefined) return "";
  const hasDecimals = Math.abs(numericValue % 1) > 0;
  return hasDecimals
    ? numericValue.toLocaleString(undefined, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })
    : numericValue.toLocaleString();
};

export const formatDeltaPercentageText = (value: number): string => {
  if (!Number.isFinite(value)) return "—";
  const magnitude = Math.abs(value);
  return `${magnitude.toFixed(1)}%`;
};

export const formatLastPeriodLabel = (
  value: number | string | undefined,
  suffix?: string,
): string | null => {
  if (value == null) return null;
  if (typeof value === "string" && value.length === 0) return null;
  const text =
    typeof value === "number" ? value.toLocaleString() : String(value);
  return `${text}${suffix ?? ""} last period`;
};
